// Generated passwords get read aloud or pasted into chat by an admin handing
// them to a user, so the alphabet drops characters that are easy to confuse:
// 0/O/o, 1/l/I.
export const PASSWORD_ALPHABET =
  "abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789";

export const PASSWORD_LENGTH = 12;

// 256 is not a multiple of the alphabet size, so the top partial block has to be
// rejected — taking `byte % length` directly would bias the earlier characters.
const REJECT_FROM =
  Math.floor(256 / PASSWORD_ALPHABET.length) * PASSWORD_ALPHABET.length;

export function generatePassword(length = PASSWORD_LENGTH) {
  const webcrypto = globalThis.crypto;
  if (webcrypto?.getRandomValues == null) {
    // Falling back to Math.random() here would silently downgrade every
    // generated password, so fail loudly instead.
    throw new Error("crypto.getRandomValues is unavailable");
  }

  let out = "";
  const buf = new Uint8Array(length);
  while (out.length < length) {
    webcrypto.getRandomValues(buf);
    for (let i = 0; i < buf.length && out.length < length; i++) {
      if (buf[i] < REJECT_FROM) {
        out += PASSWORD_ALPHABET[buf[i] % PASSWORD_ALPHABET.length];
      }
    }
  }
  return out;
}
